document.addEventListener('DOMContentLoaded', function() {
  // 1) Fallback de formatMoney
  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      // Usa el formato definido en tema, o uno por defecto simple
      return Shopify.formatMoney(cents, window.Shopify.money_format || "${{amount_no_decimals}}COP");
    } else {
      // Intl como plan B
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
      }).format(cents / 100);
    }
  }

  const selects    = document.querySelectorAll('.fbw-variant-select');
  const checkboxes = document.querySelectorAll('.fbw-checkbox');
  const totalEl    = document.getElementById('fbw-total');
  const addBtn     = document.getElementById('fbw-add');

  // 2) Función que recalcula total y repuebla precios unitarios
  function updatePricesAndTotal() {
    let sum = 0;
    checkboxes.forEach(cb => {
      const price = parseInt(cb.dataset.price, 10) || 0;
      sum += cb.checked ? price : 0;

      // repoblar el <span class="fbw-price">
      const li      = cb.closest('.fbw-item');
      const priceEl = li.querySelector('.fbw-price');
      priceEl.textContent = formatMoney(price);
    });
    totalEl.textContent = formatMoney(sum);
  }

  // 3) Listeners en cada select para actualizar su checkbox
  selects.forEach(select => {
    select.addEventListener('change', function() {
      const opt     = this.options[this.selectedIndex];
      const li      = this.closest('.fbw-item');
      const cb      = li.querySelector('.fbw-checkbox');

      cb.dataset.variantId = opt.value;
      cb.dataset.price     = opt.dataset.price;
      // actualizar imagen opcionalmente
      const img = li.querySelector('img');
      if (opt.dataset.image) img.src = opt.dataset.image;

      updatePricesAndTotal();
    });
  });

  // 4) Listener en checkboxes para recalcular total si los tachas
  checkboxes.forEach(cb => cb.addEventListener('change', updatePricesAndTotal));

  // 5) Disparar un change inicial en TODOS los selects
  selects.forEach(select => select.dispatchEvent(new Event('change')));

  // 6) Botón “Añadir a la cesta”
  addBtn.addEventListener('click', function(e) {
    e.preventDefault();
    const items = [];
    checkboxes.forEach(cb => {
      if (cb.checked) {
        items.push({ id: cb.dataset.variantId, quantity: 1 });
      }
    });
    if (!items.length) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(() => window.location.href = '/cart')
    .catch(console.error);
  });

  // 7) Llama una vez al inicio para asegurarnos que todo se vea
  updatePricesAndTotal();
});
